export default __webpack_public_path__ + "static/michelle-8e55672bd90691b406d3e9594cfa6806.png";